import { IAdvertisementBase } from '../../models/advertisements';
import cjPontanegraApi from '../apis/cjPontanegraApi';

interface ICreateAdvertisementProps {
  categoryId: string;
  couponsAmount?: number;
  couponsMaxAgeInMinutes?: number;
  couponsMaxUsagePerUser?: number;
  description?: string;
  discount?: number | null;
  expirationDate?: Date | null;
  isActive: boolean;
  sellerId: string;
  title: string;
}

export type INewAdvertisement = IAdvertisementBase;

export const createAdvertisementsService = async ({
  categoryId,
  couponsAmount,
  couponsMaxAgeInMinutes,
  couponsMaxUsagePerUser,
  description,
  discount,
  expirationDate,
  isActive,
  sellerId,
  title,
}: ICreateAdvertisementProps): Promise<INewAdvertisement> => {
  const { data } = await cjPontanegraApi.post<INewAdvertisement>(
    '/announcements',
    {
      categoryId,
      couponsAmount,
      couponsMaxAgeInMinutes,
      couponsMaxUsagePerUser,
      description,
      discount,
      expirationDate,
      isActive,
      sellerId,
      title,
    },
  );

  return data;
};
